import Lazy from 'components/Lazy.tsx';
import { lazy } from 'react';
import lazyRetry from './lazyLoader';

const WorkflowsView = Lazy(lazy(() => lazyRetry(() => import('views/workflows/WorkflowsView.tsx'))));
const WorkflowAddView = Lazy(lazy(() => lazyRetry(() => import('views/workflows/WorkflowAdd.tsx'))));
const WorkflowEditView = Lazy(lazy(() => lazyRetry(() => import('views/workflows/WorkflowEdit.tsx'))));

const ProjectWorkflowsRoutes = {
  path: '',
  children: [
    {
      path: '',
      element: <WorkflowsView />,
    },
    {
      path: 'workflows',
      element: <WorkflowsView />,
    },
    {
      path: 'workflows/add',
      element: <WorkflowAddView />,
    },
    {
      path: 'workflows/edit/:workflowId',
      element: <WorkflowEditView />,
    },
  ],
};

export default ProjectWorkflowsRoutes;
